export enum OWNER {
    Client = "client",
    Psychologist = "psychologist",
}
